document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.item-gallery').forEach((block) => {
		const items = JSON.parse(decodeURIComponent(block.dataset.items));

		const gridItems = block.querySelectorAll('.item');
		const lightbox = block.querySelector('.lightbox');

		const img = lightbox.querySelector('.lightbox-image');
		const title = lightbox.querySelector('.lightbox-title');
		const year = lightbox.querySelector('.lightbox-year');
		const price = lightbox.querySelector('.lightbox-price');
		const status = lightbox.querySelector('.lightbox-status');
		const thumbnailsContainer = lightbox.querySelector(
			'.lightbox-thumbnails',
		);
		const mainImageContainer = lightbox.querySelector('.lightbox-main');

		const filterBtns = block.querySelectorAll('.filters a');

		const prevBtn = block.querySelector('.prev');
		const nextBtn = block.querySelector('.next');
		const closeBtn = block.querySelector('.close');
		const overlay = block.querySelector('.lightbox');

		let currentImageIndex = 0;
		let currentItemImages = [];
		let currentItem = null;

		function setCurrentItem(itemIndex) {
			currentItem = items[itemIndex];
			currentItemImages =
				currentItem.images?.filter((image) => image?.url) || [];
			currentImageIndex = 0;
		}

		// FILTER
		filterBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				filterBtns.forEach((b) => {
					b.classList.remove('selected');
				});
				e.target.classList.add('selected');
				const filter = btn.dataset.filter;

				gridItems.forEach((item) => {
					item.style.display =
						filter === 'all' || item.dataset.status === filter
							? 'block'
							: 'none';
				});
			});
		});

		// OPEN LIGHTBOX
		gridItems.forEach((item) => {
			item.addEventListener('click', () => {
				const itemIndex = parseInt(item.dataset.index, 10);
				setCurrentItem(itemIndex);

				if (currentItemImages.length > 0) {
					openLightbox();
				}
			});
		});

		function openLightbox() {
			updateLightbox();
			lightbox.classList.add('active');
		}

		function updateLightbox() {
			const currentImage = currentItemImages[currentImageIndex];
			if (!currentImage || !currentItem) return;

			// Update main image
			img.src = currentImage.url;
			img.alt = currentImage.alt || '';

			// Update details
			title.textContent = currentItem.title;
			year.textContent = currentItem.year ? currentItem.year : '';
			price.textContent = currentItem.price ? currentItem.price : '';
			status.textContent = currentItem.status;

			const hasSingleImage = currentItemImages.length === 1;

			// Show/hide thumbnails and arrows based on image count
			thumbnailsContainer.style.display = hasSingleImage ? 'none' : '';
			prevBtn.style.display = hasSingleImage ? 'none' : '';
			nextBtn.style.display = hasSingleImage ? 'none' : '';

			if (hasSingleImage) {
				mainImageContainer.classList.add('single-image');
			}

			// Update thumbnails
			thumbnailsContainer.innerHTML = '';
			currentItemImages.forEach((image, index) => {
				const thumb = document.createElement('img');
				thumb.src = image.url;
				thumb.alt = image.alt || '';
				thumb.className = index === currentImageIndex ? 'active' : '';
				thumb.addEventListener('click', () => {
					currentImageIndex = index;
					updateLightbox();
				});
				thumbnailsContainer.appendChild(thumb);
			});
		}

		// NAVIGATION
		nextBtn.onclick = () => {
			if (currentItemImages.length === 0) return;
			currentImageIndex = (currentImageIndex + 1) % currentItemImages.length;
			updateLightbox();
		};

		prevBtn.onclick = () => {
			if (currentItemImages.length === 0) return;
			currentImageIndex =
				(currentImageIndex - 1 + currentItemImages.length) %
				currentItemImages.length;
			updateLightbox();
		};

		overlay.addEventListener('click', (e) => {
			if (
				e.target.className.includes('lightbox') &&
				e.target.className.includes('active')
			) {
				lightbox.classList.remove('active');
			}
		});

		document.addEventListener('keydown', (e) => {
			if (!lightbox.classList.contains('active')) return;

			if (e.key === 'Escape') {
				lightbox.classList.remove('active');
			}

			if (currentItemImages.length > 1) {
				if (e.key === 'ArrowRight') nextBtn.click();
				if (e.key === 'ArrowLeft') prevBtn.click();
			}
		});

		// CLOSE
		closeBtn.onclick = () => {
			lightbox.classList.remove('active');
		};
	});
});
